import { createElementSlot } from '@/lib/desktop-shell/element-slot';

/**
 * The shell sidebar's content while a core tool with navigation (the browser) is the side panel's
 * tab and the sidebar shows its side: the panel showing it fills the sidebar, in place of the
 * conversations, as an app's sections do.
 */
export const coreAppSidebarSlot = createElementSlot();
